module.exports = __webpack_public_path__ + "img/5.b74cd48b.png";